export default {
  '个性化设置':'Person Setting',
  '界面帮助信息':'Help Info',
  '帮助助手':'Help Assistant',
  '用户信息':'User Info',
  '进入帮助中心':'Join Help Assistant',
  '框架设置':'Frame Settings',
  '基础设置':'Basic Settings',
  '顶栏主题':'Page Header Theme',
  '菜单主题':'Page Menu Theme',
  '系统主题':'System Theme',
  '背景设置':'Background Settings',
  '经典模式':'Classic Mode',
  '应用模式':'Application Mode',
  '头部菜单':'Header App Mode',
  '二级菜单':'Secondary Menu Mode',
  '安全科技':'Security Technology',
  // '红色政务':'Red Government',
  '多级门户':'Military Green',
  '绿色环保':'Green and Environmentally',
  '白色简约':'Blue Technology',
  '大海深蓝':'Ocean Deep Blue',
  '标签页':'Tabs',
  '面包屑':'Bread Crumbs',
  '灰色模式':'Grey Mode',
  '色弱模式':'Color Weakness Mode',

  '背景类型':'Background Mode',
  '颜色背景':'Colored Background',
  '图片背景':'Picture Background',

  '图片模糊度':'Image Blurriness',
  '图片蒙版':'Image Mask',
  '自定义':'Custom  Define',

  '基础间距':"Base Space",
  '恢复默认':'Restore Default',
  '保存':'SAVE DATA',
};
